
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "width": "43px",
    "height": "36px",
    "viewBox": "0 0 43 36",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  },
  "children": [
    {
      "tag": "title",
      "children": [
        {
          "text": "编组 13"
        }
      ]
    },
    {
      "tag": "desc",
      "children": [
        {
          "text": "Created with Sketch."
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "页面-1",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "配置",
            "transform": "translate(-901.000000, -747.000000)"
          },
          "children": [
            {
              "tag": "g",
              "attrsMap": {
                "id": "编组-11",
                "transform": "translate(640.000000, 547.000000)"
              },
              "children": [
                {
                  "tag": "g",
                  "attrsMap": {
                    "id": "编组-12"
                  },
                  "children": [
                    {
                      "tag": "g",
                      "attrsMap": {
                        "id": "反馈:6/模态框:7/表格:7"
                      },
                      "children": [
                        {
                          "tag": "g",
                          "attrsMap": {
                            "id": "反馈:6/模态框/表格"
                          },
                          "children": [
                            {
                              "tag": "g",
                              "attrsMap": {
                                "id": "反馈/弹窗/模态框/表格"
                              },
                              "children": [
                                {
                                  "tag": "g",
                                  "attrsMap": {
                                    "id": "编组-5备份-6",
                                    "transform": "translate(24.000000, 126.000000)"
                                  },
                                  "children": [
                                    {
                                      "tag": "g",
                                      "attrsMap": {
                                        "id": "Rectangle-2-+-Path-6-蒙版"
                                      },
                                      "children": [
                                        {
                                          "tag": "g",
                                          "attrsMap": {
                                            "id": "编组-13",
                                            "transform": "translate(235.012193, 70.012193)"
                                          },
                                          "children": [
                                            {
                                              "tag": "polygon",
                                              "attrsMap": {
                                                "id": "Rectangle-2",
                                                "fill": "#1677FF",
                                                "transform": "translate(42.000000, 42.000000) rotate(-315.000000) translate(-42.000000, -42.000000) ",
                                                "points": "16.8061968 14 71.4577617 14.5744256 72 70 12 68.618226"
                                              }
                                            },
                                            {
                                              "tag": "polyline",
                                              "attrsMap": {
                                                "id": "Path-6",
                                                "stroke": "#FFFFFF",
                                                "stroke-width": "2",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                                "points": "37 24 28.4319058 32 25 28.7956414"
                                              }
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  